import React from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "reactstrap";
import { enWebPage } from "../../../../lib/ConstCommand";

const SmartTVModal = ({ isAlertModalOpened, currentPageType, handleSelectedFunc }) => {
    const { t } = useTranslation();

    return (
        <Modal isOpen={isAlertModalOpened} centered backdrop={false}>
            <div className="card container-fluid">
                <div className="card-body px-2">
                    <div className="title-area text-center dark-grey-text">
                        <div className="d-flex flex-column">
                            <span>
                                {t("스마트_티브이_안내_문구_9", { ns: "live" })}
                            </span>
                        </div>
                    </div>
                    <div className="content-area dark-grey-text font-md">
                        <span className="mb-1">
                            {
                                currentPageType === enWebPage.SmartTV ?
                                    t("스마트_티브이_안내_문구_10", { ns: "live" }) :
                                    t("스마트_티브이_안내_문구_11", { ns: "live" })
                            }
                        </span>
                        <span className="mb-2">
                            {t("스마트_티브이_안내_문구_12", { ns: "live" })}
                        </span>
                        <span className="small mb-1">
                            {t("스마트_티브이_안내_문구_4", { ns: "live" })}
                        </span>
                    </div>
                    <button type="button" className="btn btn-md green white-text py-1 px-2" onClick={() => handleSelectedFunc({ selectedFunc: "CLOSE_SMART_TV_MODAL" })}>{t("확인", { ns: "common" })}</button>
                </div>
            </div>
        </Modal>
    );
}

export default SmartTVModal;